"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFeedPrivacyLevels = void 0;
var IFeedPrivacyLevels;
(function (IFeedPrivacyLevels) {
    IFeedPrivacyLevels["Me"] = "me";
    IFeedPrivacyLevels["Friends"] = "friends";
    IFeedPrivacyLevels["Everyone"] = "everyone";
})(IFeedPrivacyLevels || (exports.IFeedPrivacyLevels = IFeedPrivacyLevels = {}));
//# sourceMappingURL=feed-privacy-levels.js.map